import {
  IPlatformServices,
  IWixAPI,
} from '@wix/native-components-infra/dist/src/types/types';
import { getCurrentlyUsedMultilingualLanguage } from './headers';

export function getFormattingFunction({
  wixApi,
  platformServices,
  formatingCurrency,
}: {
  wixApi: IWixAPI;
  platformServices: IPlatformServices;
  formatingCurrency?: string;
}) {
  const createCurrencyFormatter =
    platformServices.essentials.createCurrencyFormatterWithDefaults({
      language: getFormattingLanguage(wixApi),
    });
  const formatCurrency = createCurrencyFormatter();
  return (amount: string | number) =>
    formatCurrency({ value: amount, currency: formatingCurrency ?? 'USD' });
}

function getMLLocale(wixApi: IWixAPI) {
  const currentLang = getCurrentlyUsedMultilingualLanguage(wixApi);
  if (!currentLang) {
    return undefined;
  }
  return currentLang.locale || wixApi.window.multilingual.currentLanguage;
}

export function getFormattingLanguage(wixApi: IWixAPI) {
  return getMLLocale(wixApi) ?? wixApi.site.regionalSettings ?? 'en-US';
}
